import React from 'react';
import CtaLink from 'components/essentials/Cta/CtaLink';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TextComponent = ({ config }) => {
  const { header, text, cta } = config;
  const HeaderTag = header.tagName || 'h2';
  const { size = '3xl' } = header;

  return (
    <div className="text-gray mt-[30px] px-5 py-0 md:mt-[30px] md:mx-auto md:mb-0 md:!max-w-[696px] md:text-center">
      {header && (
        <HeaderTag
          className={classNames(
            "text-3xl font-bold mb-5 md:mb-[30px] before:[border-top:2px_solid_#107c8c] before:box-border before:[content:''] before:block before:h-0 before:mt-0 before:mx-0 before:mb-5 before:w-[30px] before:md:mt-0 before:md:mx-auto before:md:mb-10 before:md:w-10",
            {
              'text-3xl font-bold': size === '3xl',
              'text-[clamp(1.75rem,5.2vw,2.5rem)] leading-[clamp(2.25rem,6.25vw,3rem)] tracking-[.0125rem] font-bold':
                size === '4xl',
            }
          )}
        >
          {header.content}
        </HeaderTag>
      )}
      {text.tagName ? (
        <p className="text-base [&_a]:font-bold"> {text.content}</p>
      ) : (
        <div
          className="text-base [&_a]:font-bold [&_table]:border [&_table]:border-gray-light6 [&_table]:table-auto [&_table]:!w-full [&_td]:border [&_td]:border-gray-light6 [&_td]:align-top [&_td]:p-2 [&_table]:my-4 [&_p]:mb-2 [&_h2]:font-bold [&_h2]:text-lg [&_h2]:mt-2"
          dangerouslySetInnerHTML={{ __html: text.content }}
        />
      )}

      {!!cta && cta.content && (
        <div className="mt-8">
          <CtaLink color="brand" to={cta.linkTo}>
            {cta.content}
          </CtaLink>
        </div>
      )}
    </div>
  );
};

TextComponent.propTypes = {
  config: PropTypes.shape({
    header: PropTypes.shape({
      content: PropTypes.string,
      tagName: PropTypes.string,
      size: PropTypes.string,
    }),
    text: PropTypes.shape({
      content: PropTypes.string,
      tagName: PropTypes.string,
    }),
    cta: PropTypes.shape({
      content: PropTypes.string,
      linkTo: PropTypes.string,
    }),
  }),
};

const TextComponentUI = props => {
  if (props?.config?.elementAttribute?.id) {
    return (
      <div id={props?.config?.elementAttribute?.id}>
        <TextComponent {...props} />
      </div>
    );
  }
  return <TextComponent {...props} />;
};

TextComponentUI.propTypes = {
  config: PropTypes.shape({
    elementAttribute: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

export default TextComponentUI;
